import { css } from 'lit'

export const style = css`
  :host([implicit]) contextual-one-ux-tree {
    --contextual-one-ux-tree-element--row-border-radius: var(--one-ux-radius--300);
  }
`
